import { createSelector } from 'reselect';

import getSelectors from '../../shared/store/selectorsFactory';

import { adminPageNames } from '../../shared/adminPageNames';
import { companyCodesSelector } from '../../../shared/store/selectors';

export const sharedSelectors = getSelectors(adminPageNames.TAX_BOOKING_ENTITIES);

export const enabledFlagOptionsSelector = createSelector(
  state => state.administration[adminPageNames.TAX_BOOKING_ENTITIES].enabledFlagValues,
  enabledFlagValues => enabledFlagValues.map(({ name, value }) => ({ label: name, value }))
);

export const companyCodeOptionsSelector = createSelector(
  companyCodesSelector,
  companyCodes => companyCodes.map(({
    cc,
    fullDesc,
    legalEntity,
  }) => ({
    label: fullDesc,
    value: cc,
    legalEntity,
  }))
);

export const tbeCompanyCodeOptionsSelector = createSelector(
  state => state.administration[adminPageNames.TAX_BOOKING_ENTITIES].tbeCompanyCodes,
  tbeCompanyCodes => tbeCompanyCodes.map(({
    tbeCompanyCodeDesc,
    tbeCompanyCode,
  }) => ({
    label: tbeCompanyCodeDesc,
    value: tbeCompanyCode,
  }))
);


export const importStatusOptionsSelector = createSelector(
  state => state.administration[adminPageNames.TAX_BOOKING_ENTITIES].importStatus,
  importStatus => importStatus.map(({
    longName,
    statusID,
  }) => ({
    label: longName,
    value: statusID,
  }))
);

export const usTaxTypeOptionsSelector = createSelector(
  state => state.administration[adminPageNames.TAX_BOOKING_ENTITIES].usTaxTypeValues,
  usTaxTypeValues => usTaxTypeValues.map(({ value }) => ({ label: value, value }))
);

export const localTaxTypeOptionsSelector = createSelector(
  state => state.administration[adminPageNames.TAX_BOOKING_ENTITIES].localTaxTypeValues,
  localTaxTypeValues => localTaxTypeValues.map(({ value }) => ({ label: value, value }))
);

export const tbeTypeOptionsSelector = createSelector(
  state => state.administration[adminPageNames.TAX_BOOKING_ENTITIES].tbeTypeValues,
  tbeTypeValues => tbeTypeValues.map(({ value }) => ({ label: value, value }))
);

export const isFetchingInitialDataForModalSelector = state =>
  state.administration[adminPageNames.TAX_BOOKING_ENTITIES].isFetchingInitialDataForModal;

export const isFetchingTBECompanyCodesForModalSelector = state =>
  state.administration[adminPageNames.TAX_BOOKING_ENTITIES].isFetchingTBECompanyCodesForModal;
